export default __webpack_public_path__ + "static/media/camion.2a577ccc.svg";